import React from 'react';
import { CreditCard, Check } from 'lucide-react';

export function Billing() {
  return (
    <div className="page" data-testid="billing-page">
      <div className="page-header">
        <div className="page-header-content">
          <h1>Billing / Subscription</h1>
          <p>Manage your subscription and payment methods</p>
        </div>
      </div>

      <div className="glass-panel" style={{ marginBottom: 'var(--space-lg)' }}>
        <div className="glass-panel-header">
          <div className="glass-panel-title">
            <CreditCard size={18} className="icon" />
            Current Plan
          </div>
          <span className="status-badge active">Active</span>
        </div>
        <div className="detail-grid">
          <div className="detail-item">
            <div className="detail-item-label">Plan</div>
            <div className="detail-item-value">Professional</div>
          </div>
          <div className="detail-item">
            <div className="detail-item-label">Billing Cycle</div>
            <div className="detail-item-value">Monthly</div>
          </div>
          <div className="detail-item">
            <div className="detail-item-label">Next Payment</div>
            <div className="detail-item-value">1st February 2026</div>
          </div>
          <div className="detail-item">
            <div className="detail-item-label">Amount</div>
            <div className="detail-item-value">£29.99 / month</div>
          </div>
        </div>
      </div>

      <div className="glass-panel">
        <div className="glass-panel-header">
          <div className="glass-panel-title">Plan Features</div>
        </div>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {['Unlimited jobs', 'AI Assistant', 'Client Portal', 'Finance tracking', 'Priority support'].map((feature) => (
            <li key={feature} style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', padding: 'var(--space-sm) 0', color: 'var(--text-secondary)' }}>
              <Check size={16} style={{ color: 'var(--status-success)' }} />
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Billing;
